import { HttpRequestBuilder15f2nnx9sjuv1 as HttpRequestBuilder } from '../request/HttpRequest.mjs';
import {
  skipSaveBodyqewhiekddpy3 as skipSaveBody,
  get_isSaved1yor47kvbhumv as get_isSaved,
} from '../plugins/SaveBody.mjs';
import { unwrapCancellationException1zvbmufui4i9c as unwrapCancellationException } from '../utils/ExceptionUtils.nonJvm.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { save1y71vsgu0wj47 as save } from '../call/SavedCall.mjs';
import { get_job2zvlvce9o9a29 as get_job } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Job.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CompletableJob1w6swnu15iclo as CompletableJob } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CompletableJob.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { canceldn4b3cdqcfny as cancel } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannel.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var HttpStatementClass;
function HttpStatement() {
  if (HttpStatementClass === VOID) {
    class $ {
      constructor(builder, client) {
        this.m5x_1 = builder;
        this.n5x_1 = client;
      }
      *q5z($completion) {
        return yield* this.r5z($completion);
      }
      *o5x($completion) {
        $l$block: {
          // Inline function 'io.ktor.client.plugins.unwrapRequestTimeoutException' call
          try {
            var builder = (new (HttpRequestBuilder())()).b5m(this.m5x_1);
            skipSaveBody(builder);
            var call = yield* this.n5x_1.f5i(builder, $completion);
            return call.c5h();
          } catch ($p) {
            if ($p instanceof CancellationException()) {
              var cause = $p;
              throw unwrapCancellationException(cause);
            } else {
              throw $p;
            }
          }
        }
      }
      *r5z($completion) {
        $l$block: {
          // Inline function 'io.ktor.client.plugins.unwrapRequestTimeoutException' call
          try {
            var builder = (new (HttpRequestBuilder())()).b5m(this.m5x_1);
            var call = yield* this.n5x_1.f5i(builder, $completion);
            var result = (yield* save(call, $completion)).c5h();
            yield* this.p5x(call.c5h(), $completion);
            return result;
          } catch ($p) {
            if ($p instanceof CancellationException()) {
              var cause = $p;
              throw unwrapCancellationException(cause);
            } else {
              throw $p;
            }
          }
        }
      }
      *p5x(_this__u8e3s4, $completion) {
        var tmp = get_job(_this__u8e3s4.sv());
        var job = isInterface(tmp, CompletableJob()) ? tmp : THROW_CCE();
        // Inline function 'kotlin.apply' call
        job.k12();
        if (!get_isSaved(_this__u8e3s4)) {
          try {
            cancel(_this__u8e3s4.m5j());
          } catch ($p) {
            if ($p instanceof Error) {
              var _unused_var__etf5q3 = $p;
            } else {
              throw $p;
            }
          }
        }
        yield* job.zw($completion);
        return Unit_instance;
      }
      toString() {
        return 'HttpStatement[' + this.m5x_1.g5i_1.toString() + ']';
      }
    }
    initMetadataForClass($, 'HttpStatement', VOID, VOID, VOID, [1, 0]);
    HttpStatementClass = $;
  }
  return HttpStatementClass;
}
//region block: exports
export {
  HttpStatement as HttpStatement3zxb33q8lku,
};
//endregion

//# sourceMappingURL=HttpStatement.mjs.map
